const SUPABASE_URL = 'https://drzjezvkopukxcgxzaqo.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRyemplenZrb3B1a3hjZ3h6YXFvIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODUxMTM4NjYsImV4cCI6MjAwMDY4OTg2Nn0.m5Ccq0HnoxTN9_U0EoBfWlshbDY7JZI1jGlhn5f4qAc';

export {
  SUPABASE_URL,
  SUPABASE_KEY,
}